import Modal from "react-modal"

Modal.defaultStyles.overlay.backgroundColor = "rgba(0, 0, 0, 0.5)";
Modal.defaultStyles.overlay.zIndex = 1100;
Modal.defaultStyles.overlay.textAlign = "center";
Modal.defaultStyles.content.maxWidth = "842px";
Modal.defaultStyles.content.left = "auto";
Modal.defaultStyles.content.right = "auto";
Modal.defaultStyles.content.position = "relative";
Modal.defaultStyles.content.display = "inline-block";
Modal.defaultStyles.content.borderRadius = "16px";
Modal.defaultStyles.content.top = "120px";

Modal.setAppElement(document.body)

export default Modal
